function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40",
  fill: "none",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "currentColor",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 20.91v6.34L20 32.5l9.5-5.25v-6.34m-19-6.16L20 9.5l9.5 5.25m-19 0L5 11.71l9.38-5.32L20 9.5m9.5 5.25l5.5-3.04-9.37-5.32L20 9.5m9.5 5.25l5.5 3.04-9.37 5.32L20 20l9.5-5.25zM20 32.5V20l-5.62 3.11L5 17.79l5.5-3.04L20 20"
}));